// 导入组件
import layout from './src/layout.vue'

// 为组件提供 install 安装方法，供按需引入
layout.install = function (Vue) {
  Vue.component(layout.name, layout)
}

// 默认导出组件
export default layout
